module.exports = __webpack_public_path__ + "img/ry-2.d9f4dbdc.png";